import { render, staticRenderFns } from "./SemenStorageDiagramPage.vue?vue&type=template&id=6c316624&scoped=true&"
import script from "./SemenStorageDiagramPage.vue?vue&type=script&lang=js&"
export * from "./SemenStorageDiagramPage.vue?vue&type=script&lang=js&"
import style0 from "./SemenStorageDiagramPage.vue?vue&type=style&index=0&id=6c316624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c316624",
  null
  
)

export default component.exports